import { Components, ThemeOptions } from "@mui/material";
import { ThemeSet } from "./ThemeSet";

// Dark theme is based on these guidelines
// https://material.io/design/color/dark-theme.html

// Color palettes tool
// https://material.io/inline-tools/color/

// Light Theme Colors
// https://material.io/resources/color/#!/?view.left=0&view.right=0&primary.color=283854&secondary.color=2ac6b4

// Dark Theme Colors
// https://material.io/resources/color/#!/?view.left=0&view.right=0&primary.color=b7c0cc&secondary.color=76d7ca

declare module "@mui/material/styles" {
    interface Palette {
        custom: {
            wellCategory: {
                atRisk: React.CSSProperties["color"],
                isDown: React.CSSProperties["color"],
                isProducing: React.CSSProperties["color"],
                isUnknown: React.CSSProperties["color"],
            },
            background: {
                1: React.CSSProperties["color"],
                2: React.CSSProperties["color"],
                cardContainer: React.CSSProperties["color"];
            },
            dashboard: {
                border: {
                    section: React.CSSProperties["color"],
                    row: React.CSSProperties["color"],
                    column: React.CSSProperties["color"],
                    selected: React.CSSProperties["color"],
                },
                background: {
                    column: React.CSSProperties["color"],
                    row: React.CSSProperties["color"],
                    hover: React.CSSProperties["color"],
                },


            }
        };
    }

    interface PaletteOptions {
        custom?: {
            wellCategory?: {
                atRisk: React.CSSProperties["color"],
                isDown: React.CSSProperties["color"],
                isProducing: React.CSSProperties["color"],
                isUnknown: React.CSSProperties["color"],
            },
            background: {
                1: React.CSSProperties["color"],
                2: React.CSSProperties["color"],
                cardContainer: React.CSSProperties["color"];
            },
            dashboard: {
                border: {
                    section: React.CSSProperties["color"],
                    row: React.CSSProperties["color"],
                    column: React.CSSProperties["color"],
                    selected: React.CSSProperties["color"],
                },
                background: {
                    column: React.CSSProperties["color"],
                    row: React.CSSProperties["color"],
                    hover: React.CSSProperties["color"],
                },
            }
        };
    }
}

// Override component defaults here
const components: Components = {
    MuiLink: {
        defaultProps: {
            underline: "none",
        }
    },
    MuiUseMediaQuery: {
        defaultProps: {
            noSsr: true
        }
    },
    MuiCheckbox: {
        defaultProps: {
            color: "secondary"
        }
    },
    MuiRadio: {
        defaultProps: {
            color: "secondary"
        }
    },
    MuiSwitch: {
        defaultProps: {
            color: "secondary"
        }
    },
    MuiListItemIcon: {
        defaultProps: {
            sx: {
                minWidth: '56px'
            }
        }
    }
};

const light: ThemeOptions = {
    palette: {
        mode: "light",
        primary: {
            light: "rgba(84, 99, 130, 1)",
            main: "rgba(41, 57, 85, 1)",
            dark: "rgba(0, 19, 44, 1)",
            contrastText: "#fff"
        },
        secondary: {
            light: "rgba(109, 250, 230, 1)",
            main: "rgba(42, 198, 180, 1)",
            dark: "rgba(0, 149, 132, 1)",
            contrastText: "#fff"
        },
        // text: {
        //     primary: "rgba(0, 0, 0, 0.87)",
        //     secondary: "rgba(0, 0, 0, 0.6)",
        //     disabled: "rgba(0, 0, 0, 0.38)"
        // },
        // divider: "rgba(0, 0, 0, 0.12)",
        // background: {
        //     paper: "#fff",
        //     default: "#fff"
        // },
        action: {
            // active: "rgba(0, 0, 0, 0.54)",
            // hover: "rgba(0, 0, 0, 0.04)",
            // hoverOpacity: 0.04,
            selected: "rgba(33, 150, 243, 0.08)",
            selectedOpacity: 0.08,
            // disabled: "rgba(0, 0, 0, 0.26)",
            // disabledBackground: "rgba(0, 0, 0, 0.12)",
            // disabledOpacity: 0.38,
            // focus: "rgba(0, 0, 0, 0.12)",
            // focusOpacity: 0.12,
            // activatedOpacity: 0.12
        },
        custom: {
            wellCategory: {
                atRisk: "#f8bb54",
                isDown: "#8a75e3",
                isProducing: "#566580",
                isUnknown: "#fe8f96"
            },
            background: {
                1: "#eeeeee",
                2: "#e0e0e0",
                cardContainer: "rgba(0, 0, 0, 0.06)"
            },
            dashboard: {
                border: {
                    section: "#7fff00",
                    row: '#ff0000',
                    column: "#a9a9a9",
                    selected: "#2ac6b4"
                },
                background: {
                    column: "#d3d3d3",
                    row: "#5f9ea0",
                    hover: "#00bcd4"
                }
            }
        }
    },
    // typography: {
    //     body1: {
    //         fontSize: '0.875rem',
    //       }
    // }
    components: components
};

const dark: ThemeOptions = {
    palette: {
        mode: "dark",
        primary: {
            light: "#e9f3ff",
            main: "#b7c0cc",
            dark: "#87909b",
            contrastText: "#000"
        },
        secondary: {
            light: "#a9fffd",
            main: "#76d7ca",
            dark: "#42a599",
            contrastText: "#000"
        },
        // text: {
        //     primary: "#fff",
        //     secondary: "rgba(255, 255, 255, 0.7)",
        //     disabled: "rgba(255, 255, 255, 0.5)"
        // },
        // divider: "rgba(255, 255, 255, 0.12)",
        // background: {
        //     // paper: "#424242",
        //     // default: "#303030"
        //     paper: "#121212",
        //     default: "#121212"
        // },
        action: {
            // active: "#fff",
            // hover: "rgba(255, 255, 255, 0.08)",
            // hoverOpacity: 0.08,
            selected: "rgba(33, 150, 243, 0.16)",
            selectedOpacity: 0.16,
            // disabled: "rgba(255, 255, 255, 0.3)",
            // disabledBackground: "rgba(255, 255, 255, 0.12)",
            // disabledOpacity: 0.38,
            // focus: "rgba(255, 255, 255, 0.12)",
            // focusOpacity: 0.12,
            // activatedOpacity: 0.24
        },
        custom: {
            wellCategory: {
                atRisk: "#f8bb54",
                isDown: "#8a75e3",
                isProducing: "#566580",
                isUnknown: "#fe8f96"
            },
            background: {
                1: "#313131",
                2: "#424242",
                cardContainer: "#121212"
            },
            dashboard: {
                border: {
                    section: "#7fff00",
                    row: '#ff0000',
                    column: "#a9a9a9",
                    selected: "#2ac6b4"
                },
                background: {
                    column: "#d3d3d3",
                    row: "#5f9ea0",
                    hover: "#00bcd4"
                }
            }
        }
    },
    // typography: {
    //     body1: {
    //         fontSize: '0.875rem',
    //       }
    // }
    components: components
};

const appHeaderV1: ThemeOptions = {
    palette: {
        mode: "dark",
        primary: {
            light: "#e9f3ff",
            main: "#b7c0cc",
            dark: "#87909b",
            contrastText: "#000"
        },
        secondary: {
            light: "#a9fffd",
            main: "#76d7ca",
            dark: "#42a599",
            contrastText: "#000"
        }
    },
    components: components
};

const appHeaderV2Light: ThemeOptions = {
    palette: {
        mode: "light",
        primary: {
            light: "#ffffff",
            main: "#ffffff",
            dark: "#ffffff",
            contrastText: "rgba(41, 57, 85, 1)"
        },
        secondary: {
            light: "rgba(42, 198, 180, 1)",
            main: "rgba(42, 198, 180, 1)",
            dark: "rgba(42, 198, 180, 1)",
            contrastText: "rgb(10, 10, 10)"
        },
        text: {
            primary: "rgba(41, 57, 85, 1)",
            secondary: "rgba(41, 57, 85, 1)"
        },
        background: {
            paper: "#ffffff",
            default: "#ffffff"
        }
    },
    components: components
};

const appHeaderV2Dark: ThemeOptions = {
    palette: {
        mode: "dark",
        primary: {
            light: "#e9f3ff",
            main: "#b7c0cc",
            dark: "#87909b",
            contrastText: "#000"
        },
        secondary: {
            light: "#a9fffd",
            main: "#76d7ca",
            dark: "#42a599",
            contrastText: "#000"
        }
    },
    components: components
};

const contextualAppHeaderV2Light: ThemeOptions = {
    palette: {
        mode: "light",
        primary: {
            light: "rgba(84, 99, 130, 1)",
            main: "rgba(41, 57, 85, 1)",
            dark: "rgb(44, 0, 1)",
            contrastText: "#ffffff"
        },
        secondary: {
            light: "rgba(109, 250, 230, 1)",
            main: "rgba(42, 198, 180, 1)",
            dark: "rgba(0, 149, 132, 1)",
            contrastText: "#dd131311"
        },
        text: {
            primary: "#fff",
            secondary: "rgba(255, 255, 255, 0.7)",
            disabled: "rgba(255, 255, 255, 0.5)"
        },
        action: {
            disabled: "rgba(255, 255, 255, 0.3)",
        }
    },
    components: components
};

const contextualAppHeaderV2Dark: ThemeOptions = {
    palette: {
        mode: "dark",
        primary: {
            light: "#e9f3ff",
            main: "#b7c0cc",
            dark: "#87909b",
            contrastText: "#000"
        },
        secondary: {
            light: "#a9fffd",
            main: "#76d7ca",
            dark: "#42a599",
            contrastText: "#000"
        },
    },
    components: components
};

export default {
    name: "default",
    mode: "light",
    light: {
        main: light,
        appHeaderV1: appHeaderV1,
        appHeaderV2: appHeaderV2Light,
        contextualAppHeaderV2: contextualAppHeaderV2Light
    },
    dark: {
        main: dark,
        appHeaderV1: appHeaderV1,
        appHeaderV2: appHeaderV2Dark,
        contextualAppHeaderV2: contextualAppHeaderV2Dark
    }
} as ThemeSet;
